<template>
  <AutoComplete
    v-model="model"
    field="employeName"
    inputClass="form-control"
    :suggestions="values"
    :dropdown="false"
    placeholder="Ingrese la busqueda..."
    :class="classes"
    :disabled="disabled"
    @item-select="onChange"
    @complete="onComplete($event)"
  >
    <template #item="{ item }">
      <div>
        <span>{{ item.number_document }} - {{ item.employeName }}</span>
      </div>
    </template>
  </AutoComplete>
</template>

<script>
import { ref, watch } from 'vue'
import searchEmployees from '../../../../../services/searchEmployees'

export default {
  name: 'AutocompleteEmployees',
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    classes: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {
    const values = ref([])
    const model = ref({
      employeID: '',
      employeName: ''
    })
    /**/
    const onComplete = ({ query }) => {
      return searchEmployees({ value: query.trim() }).then(({ data }) => {
        values.value = data
      }).catch(err => {
        console.error(err.message)
      })
    }
    /**/
    const onChange = ({ value }) => {
      context.emit('update:modelValue', value.employeID)
    }
    /**/
    const setEmployees = () => {
      values.value = []
      model.value = { employeID: '', employeName: '' }
      if (props.modelValue) {
        searchEmployees({ value: props.modelValue, type: 1 }).then(({ data }) => {
          values.value = data
          model.value = data[0]
          context.emit('update:modelValue', props.modelValue)
        }).catch(err => {
          console.error(err.message)
        })
      }
    }
    /**/
    watch(() => props.modelValue, (value) => {
      setEmployees()
    })

    return {
      model,
      values,
      onComplete,
      onChange
    }
  }
}
</script>

<style scoped>

</style>
